module.exports = __webpack_public_path__ + "f414195db52ec8b2e351fd8dc5045ae1.jpg";